export const copyToClipboard = (str: string) => {
    const el = document.createElement("textarea")
    el.value = str
    el.setAttribute("readonly", "")
    el.style.position = "absolute"
    el.style.left = "-9999px"
    document.body.appendChild(el)
    const sel = document.getSelection()
    const selected =
        sel !== null && sel.rangeCount > 0 ? sel.getRangeAt(0) : false
    el.select()
    document.execCommand("copy")
    document.body.removeChild(el)
    if (sel && selected) {
        sel.removeAllRanges()
        sel.addRange(selected)
    }
}
